const SPECIAL_CHAR_CODE_REGEXP = /&#(x?[^;]+);/

/**
 * Transforms backend API currency HTML entity to a React-compatible text representation.
 *
 * @example
 * // returns ¥
 * getPureCurrencyRepresentation('&#x00A5;')
 *
 * @param {string} currency
 * @return {string}
 */
export default (currency) => {
    if (typeof currency !== 'string') {
        return '';
    }
    let sign = '';
    const [ entry, code ] = SPECIAL_CHAR_CODE_REGEXP.exec(currency) || [null, null];
    if (code && code) {
        // noinspection JSCheckFunctionSignatures
        sign = String.fromCharCode('0' + code);
    }
    return currency.replace(entry, sign);
}
